import React from "react"

import Layout from "../components/layout"
import Section from "../components/Section"
import Wave from "../components/Wave"

import styled from "styled-components"

const SectionCaption = styled.p`
  font-weight: 600;
  font-size: 60px;
  text-transform: uppercase;
  text-align: center;
  background: linear-gradient(104deg, #050a27 0%, #4a548c 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  span {
    -webkit-text-fill-color: initial;
  }
`

const APIContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 1fr;
  gap: 20px;

  margin: 50px auto;
  @media (max-width: 640px) {
    grid-template-columns: 100% auto;
  }
`

const APIImageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  align-self: center;
`

const APIImage = styled.img`
  max-width: 500px;
`

const APITextContainer = styled.div`
  justify-self: center;
  max-width: 500px;
  text-align: center;
`
const APITextTitle = styled.h3`
  font-size: 60px;
  background: linear-gradient(104deg, #050a27 0%, #4a548c 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 640px) {
    font-size: 40px;
  }
`
const APIText = styled.p`
  max-width: 700px;
  text-align: justify;
  line-height: 1.5;
  margin-bottom: 50px;
  background: linear-gradient(104deg, #050a27 0%, #4a548c 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 640px) {
    text-align: center;
    padding: 0 20px;
  }
`
const APILink = styled.a`
  color: white;
  background: #1890ff;
  padding: 15px 30px;
  border-radius: 10px;
`

const PartnersContainer = styled.div`
  display: grid;

  grid-template-rows: 200px 1fr;
  gap: 20px;
  margin: 150px 0;

  @media (max-width: 640px) {
    margin: 10 0px 0;
  }
`

const PartnersTitle = styled.h3`
  justify-self: center;
  font-size: 60px;
  background: linear-gradient(104deg, #050a27 0%, #4a548c 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`
const PartnersImgCotnainer = styled.div`
  justify-self: center;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  max-width: 800px;

  @media (max-width: 640px) {
    grid-template-columns: 100%;
  }
`

const PartnersImg = styled.img`
  justify-self: center;
  align-self: center;
  margin: 0 12px;

  @media (max-width: 640px) {
    margin: 12px;
  }
`
const WaveBottom = styled.div`
  margin-bottom: -6px;
`
const IndexPage = () => (
  <Layout>
    <div className="Hero">
      <div className="HeroGroup">
        <h1>
          Sistema de <br /> Transparencia <br /> Presupuestaria
        </h1>
        <p>La data que te mereces</p>
        <a target="__blank" href="https://stp-panama.netlify.app/">
          Pruébalo ya
        </a>{" "}
        <br />
        <div className="Logos">
          <img
            src={require("../static/images/logo-sketch.png")}
            width="50"
            alt="sketch-logo"
          />
          <img
            src={require("../static/images/logo-figma.png")}
            width="50"
            alt="figma-logo"
          />
          <img
            src={require("../static/images/logo-studio.png")}
            width="50"
            alt="studio-logo"
          />
          <img
            src={require("../static/images/logo-framer.png")}
            width="50"
            alt="framer-logo"
          />
          <img
            src={require("../static/images/logo-react.png")}
            width="50"
            alt="react-logo"
          />{" "}
          <img
            src={require("../static/images/logo-swift.png")}
            width="50"
            alt="swift-logo"
          />
        </div>
        <Wave />
      </div>
    </div>

    <div id="patrocinadores" className="Cards">
      <h2>Patrocinadores </h2>
      <div className="PatrocinadoresGroup">
        <div className="PImages">
          <a target="__blank" href="https://www.trustfortheamericas.org/">
            <img
              className="PLogo"
              alt="..."
              src={require("../static/images/logo-trust.png")}
            />
          </a>{" "}
          <a target="__blank" href="https://www.oas.org/es/">
            <img
              className="PLogo"
              alt="..."
              src={require("../static/images/oea-logo.png")}
            />
          </a>
          <a target="__blank" href="https://pa.usembassy.gov/es/">
            <img
              className="PLogo"
              alt="..."
              src={require("../static/images/us-logo.png")}
            />
          </a>
        </div>

        <div className="PTextoContainer">
          <h4>¿Que es Trust for the Americas?</h4>
          <p className="trust-p">
            El Trust for the Americas es un afiliado sin fines de lucro de la
            Organización de Estados Americanos que trabaja para promover el
            desarrollo económico, social y político en América Latina y el
            Caribe. Establecido en 1997, funciona a través de asociaciones
            públicas y privadas.
          </p>
          <h4> Nuestra Misión </h4>
          <p className="trust-p">
            Promover la inclusión social y económica de comunidades vulnerables
            en las Américas a través de alianzas con el sector público, privado
            y sin fines de lucro.
          </p>
          <h4>Nuestra Visión</h4>
          <p className="trust-p">
            Contribuir a una región pacífica y justa, donde todos encuentren la
            oportunidad de triunfar y prosperar.
          </p>
        </div>
      </div>
    </div>
    <div id="sobreNosotros">
      <Section
        image={require("../static/images/andrej-lisakov-g3z-CgUiPtg-unsplash.jpg")}
        logo={require("../static/images/undraw_Graduation_ktn0.svg")}
        title="Sobre Nosotros"
      />
    </div>

    <SectionCaption id="technology">
      API Público{" "}
      <span role="img" aria-label="jsx-a11y/accessible-emoji">
        ⚡
      </span>
    </SectionCaption>

    <APIContainer>
      <APITextContainer>
        <APITextTitle>Acceso Directo a la Información</APITextTitle>
        <APIText>
          Exponemos un API público para que cualquier ente independiente, ya sea
          particular, empresarial u organización no gubernamental, pueda
          consultar los datos administrados por el sistema y ser usados, sin
          justificación alguna al gobierno, para cualquier tipo de escrutinio o
          transformación, incluyendo pero no limitando al reportaje, la
          presentación y el análisis; respetando la libre publicación y
          propiedad sobre dichas transformaciones y escrutinios.
        </APIText>

        <APILink
          target="__blank"
          href="https://documenter.getpostman.com/view/6212290/TVKJwuAW"
        >
          Accede aquí
        </APILink>
      </APITextContainer>

      <APIImageContainer>
        <APIImage
          src={require("../static/images/undraw_server_cluster_jwwq.svg")}
        />
      </APIImageContainer>
    </APIContainer>

    <WaveBottom></WaveBottom>
    <PartnersContainer id="aliados">
      <PartnersTitle>Aliados</PartnersTitle>

      <PartnersImgCotnainer>
        <PartnersImg
          style={{ maxWidth: "150px" }}
          src={require("../static/images/utp-logo.png")}
        />
        <PartnersImg
          style={{ maxWidth: "300px" }}
          src={require("../static/images/antai-logo.png")}
        />

        <PartnersImg
          style={{ maxWidth: "150px" }}
          src={require("../static/images/fisc-logo.png")}
        />
      </PartnersImgCotnainer>
    </PartnersContainer>
    <WaveBottom>
      <Wave color="#f1f3f5" />
    </WaveBottom>
  </Layout>
)

export default IndexPage
